import { LatLngTuple } from "app/utils/routeMapGeo";

export function isPointInBounds(
  point: LatLngTuple,
  southWest: LatLngTuple,
  northEast: LatLngTuple
): boolean {
  const [lat, lng] = point;
  const minLat = Math.min(southWest[0], northEast[0]);
  const maxLat = Math.max(southWest[0], northEast[0]);
  const minLng = Math.min(southWest[1], northEast[1]);
  const maxLng = Math.max(southWest[1], northEast[1]);
  return lat >= minLat && lat <= maxLat && lng >= minLng && lng <= maxLng;
}

export function isPointInPolygon(point: LatLngTuple, polygon: LatLngTuple[]): boolean {
  if (polygon.length < 3) {
    return false;
  }

  const [x, y] = point;
  let inside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i, i += 1) {
    const [xi, yi] = polygon[i];
    const [xj, yj] = polygon[j];
    const intersects =
      (yi > y) !== (yj > y) &&
      x < ((xj - xi) * (y - yi)) / (yj - yi + Number.EPSILON) + xi;
    if (intersects) {
      inside = !inside;
    }
  }

  return inside;
}
